import React from "react";
import WebPageLayout from "../../../../../layouts/WebPageLayout";
import TablePageLayout from "../../../../../layouts/TablePageLayout";
import {Button, DataTable} from "react-native-paper";
import {Entypo, Ionicons} from "@expo/vector-icons";
import {BaseFilters} from "../../../../../../web/hooks/useFilters";
import {CoreTable} from "../../../../../components/CoreTable";
import {TouchableOpacity} from "react-native";
import {getSystemScreenHeaders} from "../../../system-screen-headers";
import useEntityListPage from "../../../../../hooks/useEntityListPage";
import {useDeleteFallOutMutation, useLazyGetFallOutListQuery} from "../../../../../../../store/services/api/fall-out-api";

export default function FallOutListScreen() {
  const {
    navigateToCreate,
    navigateToEdit,
    deleteEntity,
    filter,
    tableData,
    isLoading
  } = useEntityListPage<BaseFilters>({
    entityName: "FallOut",
    lazyTableQuery: useLazyGetFallOutListQuery,
    deleteEntityMutation: useDeleteFallOutMutation,
    filterDefinition: {
      sortedColumn: "",
      sortedColumnAscending: false,
      pageNumber: 1,
      pageSize: 50
    },
  });

  return (
    <WebPageLayout header={getSystemScreenHeaders()}>
      <TablePageLayout
        actions={(
          <Button icon='plus' mode="elevated" onPress={navigateToCreate} buttonColor='#fff' textColor='#0f0f0f'>
            Add Fault Code
          </Button>
        )}
      >
        <CoreTable<any>
          isLoading={isLoading}
          headers={[
            { text: 'Fault Code', sortedName: "fallOutCode" },
            { text: 'Actions', flex: 0.5 }
          ]}
          data={tableData}
          keyExtractor={(item) => item.id}
          renderItem={({item}) => (
            <DataTable.Row key={item.id}>
              <DataTable.Cell>{item.fallOutCode}</DataTable.Cell>
              <DataTable.Cell style={{flex: 0.5}}>
                <TouchableOpacity onPress={() => navigateToEdit(item.id)}>
                  <Entypo name="pencil" size={24} color="black" />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => deleteEntity(item)}>
                  <Ionicons name="ios-remove-circle" size={24} color="red" />
                </TouchableOpacity>
              </DataTable.Cell>
            </DataTable.Row>
          )}
          filters={filter.filters}
          setFilter={filter.setFilter}
        />
      </TablePageLayout>
    </WebPageLayout>
  )
}
